import script from "./ESportsCompetition.vue?vue&type=script&setup=true&lang=js"
export * from "./ESportsCompetition.vue?vue&type=script&setup=true&lang=js"

import "./ESportsCompetition.vue?vue&type=style&index=0&id=51099df4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51099df4"]])

export default __exports__